module.exports = __webpack_public_path__ + "img/01_es_mi_meg_igy_is_tovab_elunk-01 copy.39d20b0d.jpg";